import React, { useState } from "react";
import { FadeComponent } from "../fadediv/FadeComponent";

export const BadPossessions = ({ show = true }) => {
  const [loaderStatus, setLoaderStatus] = useState(true);

  const pageUrl = "/api/explained/bad-possession-rate";

  return (
    <FadeComponent show={show}>
      <>
        <div className="container stats-explained">
          <div className="text-left">
            <h2>Bad Possessions</h2>

            <div className="gray-background-container" style={{ marginBottom: "50px", marginTop: "30px" }}>
              <h5 className="sq-points-tittle" style={{ marginBottom: "30px" }}>
                Bad Possessions
              </h5>

              <p className="text-template">
                If a player has possession that is below the 33rd percentile (of all college basketball) then they're
                credited with a bad possession.
              </p>
              <p className="bold-text">The 33rd percentile is 0.77 SQpoints for this past season.</p>
              <p className="text-template">
                So, if a player shot a contested three pointer less than 26% then that'd constitute as a bad possession.
                Because the SQpoints would be less than 0.77
              </p>
              <p className="text-template">
                Or, if a player took a contested 2 point shot that had below a 39% conversion then that would also count
                as a bad possession. Because the SQpoints would be less than 0.77
              </p>
            </div>
          </div>

          <div className="gray-background-container" style={{ marginBottom: "150px", marginTop: "30px" }}>
            <h5 className="sq-points-tittle" style={{ marginBottom: "30px" }}>
              Bad Possession Rate (BPR)
            </h5>

            <p className="text-template">
              This is simply the amount of bad possessions a player had divided by total possessions.
            </p>

            <p className="bold-text">
              Let's say Player-X had 3 possessions with SQpoints below 0.77 <br /> And had 7 possessions with SQpoints
              above 0.77.
            </p>

            <p className="bold-text">
              Then Player X's Bad Possession Rate:
              <br />3 (Bad Possessions)/ 10 (Total Possessions) = 30%
            </p>

            <div className="row align-items-center">
              <div className="box col-lg-12">
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th className="w-50">
                          Rating
                          {/* <i className="fa fa-sort-desc" aria-hidden="true" /> */}
                        </th>
                        <th className="w-50">
                          BPR
                          {/* <i className="fa fa-sort-desc" aria-hidden="true" /> */}
                          <div className="tooltipCon">
                            <b className="d-block">Bad Possession Rate</b>
                            The percent of possessions that are in the 33rd percentile or below (based on SQpoints). The
                            33rd percentile is 0.77 SQpoints.
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Excellent</td>
                        <td>10% or less</td>
                      </tr>
                      <tr>
                        <td>Great</td>
                        <td>15%</td>
                      </tr>
                      <tr>
                        <td>Above Average</td>
                        <td>20%</td>
                      </tr>
                      <tr>
                        <td>Average</td>
                        <td>25%</td>
                      </tr>
                      <tr>
                        <td>Below Average</td>
                        <td>30%</td>
                      </tr>
                      <tr>
                        <td>Poor</td>
                        <td>35%</td>
                      </tr>
                      <tr>
                        <td>Awful</td>
                        <td>40% or more</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </FadeComponent>
  );
};
